import {Controller} from "stimulus"
import {PDFDocument, StandardFonts} from "pdf-lib"

export default class extends Controller {
    static targets = [
        'birthCountrySelect',
        'fieldset'
    ]

    static values = {
        country: String,
        optionnalInputs: Array
    }

    connect() {
        // Avoid UI flickering
        Turbolinks.clearCache();
        // Delay to let Select2 instances to correctly initialize
        setTimeout(() => {
          this.setTextInputs();
        }, 10)
    }

    setTextInputs() {
        this.fieldsetTargets.forEach(fieldset => {
            if (this.optionnalInputsValue.includes(fieldset.dataset.fieldsetName)) {
                if (this.birthCountrySelectTarget.value === this.countryValue) {
                    fieldset.disabled = true;
                    fieldset.style.display = 'none';
                } else {
                    fieldset.disabled = false;
                    fieldset.style.display = 'block';
                }
            }
        })
    }
}
